import '../../../../../../../util/styles/index.js';
import { useAdsStyles } from '../../../../../../../util/styles/hooks/useAdsStyles.js';

var useSelectionListItemContainer = function useSelectionListItemContainer() {
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var containerStyle = mapAdsStyles({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '4'
  });
  return {
    containerProps: containerStyle
  };
};

export { useSelectionListItemContainer };
//# sourceMappingURL=useSelectionListItemContainer.js.map
